import React from 'react';
import Button from '../common/Button';

const BasicInfoTab = ({ 
    basicInfo, 
    onBasicInfoChange, 
    onUpdateBasicInfo, 
    loading, 
    error 
}) => {
    return (
        <form onSubmit={onUpdateBasicInfo} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Specialization
                    </label>
                    <input
                        type="text"
                        value={basicInfo.specialization}
                        onChange={e => onBasicInfoChange('specialization', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Experience (Years)
                    </label>
                    <input
                        type="number"
                        value={basicInfo.experienceYears}
                        onChange={e => onBasicInfoChange('experienceYears', parseInt(e.target.value))}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                    />
                </div>
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Bio
                </label>
                <textarea
                    value={basicInfo.bio}
                    onChange={e => onBasicInfoChange('bio', e.target.value)}
                    rows={4}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
            </div>
            <div className="flex justify-end">
                <Button
                    type="submit"
                    variant="primary"
                    loading={loading}
                >
                    Update Basic Information
                </Button>
            </div>
        </form>
    );
};

export default BasicInfoTab; 